module.exports = __webpack_public_path__ + "static/media/location.43bd99bf.svg";